// src/services/defined.ts
function defined(value) {
  return value !== null && value !== void 0;
}
function notDefined(value) {
  return value === null || value === void 0;
}

// src/services/nullish-converters.ts
function nullToUndefined(value) {
  if (defined(value)) {
    return value;
  }
  return void 0;
}
function undefinedToNull(value) {
  return value ?? null;
}

// src/services/raise-nullish.ts
import { raise } from "@vy/err";
function raiseIfNullish(value, nullError) {
  if (notDefined(value)) {
    return raise(nullError);
  }
}

// src/services/when-defined.ts
function whenDefined(value, operationOnValue, defaultValue) {
  return defined(value) ? operationOnValue(value) : defaultValue;
}

// src/services/when-not-defined.ts
function whenNotDefined(value, operationOnValue, defaultValue = void 0) {
  return notDefined(value) ? defaultValue : operationOnValue(value);
}

// src/types/null-error-codes.ts
var NULL_ERROR_CODES = Object.freeze({
  UNEXPECTED_NULL: "UNEXPECTED_NULL"
});

// src/errors/null-error.ts
import { VyBaseError } from "@vy/err";
var NullError = class extends VyBaseError {
  constructor(nameOfNullishValue, errorInput) {
    const message = errorInput?.message ?? "Unexpected nullish value";
    const code = errorInput?.code ?? NULL_ERROR_CODES.UNEXPECTED_NULL;
    const metadata = {
      ...errorInput?.metadata,
      nameOfNullishValue
    };
    super({
      message,
      code,
      metadata
    });
  }
};
export {
  NullError,
  defined,
  notDefined,
  nullToUndefined,
  raiseIfNullish,
  undefinedToNull,
  whenDefined,
  whenNotDefined
};
